<template>
  <div class="app-container">
    <div class="main">
      <h5>
        项目
        <span v-if="!curId">新增</span>
        <span v-else>编辑</span>
      </h5>
      <el-form ref="taskFormRefs" :disabled="callType == 'info'" label-position="top" :model="taskForm" :rules="rules" v-show="showSearch">
        <div class="formFlxe">
          <!--基本信息-->
          <div class="formLabelLeft">
            <h5>基本信息</h5>
            <el-form-item label="项目名称" prop="projectName" label-width="100%">
              <el-input style="width: 100%" v-model="taskForm.projectName" placeholder="请输入项目名称" clearable />
            </el-form-item>
            <el-form-item label="施工许可/备案号" prop="approvalNumber" label-width="100%">
              <el-input style="width: 100%" v-model="taskForm.approvalNumber" placeholder="请输入施工许可/备案号" clearable />
            </el-form-item>
            <el-form-item label="项目地址" prop="address" label-width="100%">
              <el-input style="width: 100%" v-model="taskForm.projectAddressStr" placeholder="详细地址，如：XX路XX号" clearable />
            </el-form-item>
            <el-form-item label="项目金额(万元) " prop="projectBudget" label-width="100%">
              <el-input style="width: 100%" v-model="taskForm.projectBudget" placeholder="请输入项目金额" clearable />
            </el-form-item>
            <p style="color: #666; font-size: 12px;opacity: 0; user-select: none">注：总包负责人负责二维码管理及投诉处置，请正确选择！</p>
          </div>
          <!--单位信息-->
          <div class="formLabelRight">
            <h5>单位信息</h5>
            <el-form-item label="总包单位" prop="generalContractor" label-width="100%">
<!--              <el-input style="width: 100%" v-model="taskForm.generalContractor" placeholder="请输入总包单位" clearable />-->
              <el-select filterable  style="width: 100%" v-model="taskForm.generalContractorId" placeholder="请选择总包单位" @change="handleChangeContractor" clearable>
                <el-option
                    v-for="item in generalContractorOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="总包负责人" required prop="generalContractorContact" label-width="100%">
<!--              <el-input style="width: 48%; margin-right: 10px" v-model="taskForm.generalContractorContact" placeholder="请输入负责人姓名" clearable />-->
              <el-select style="width: 48%; margin-right: 10px" v-model="taskForm.generalContractorContactId" placeholder="选择负责人" @change="handleChangeContractorContact" clearable>
                <el-option
                    v-for="item in generalContractorContactOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                />
              </el-select>
              <el-input style="width: 48%" v-model="taskForm.generalContractorPhone" placeholder="负责人手机号" clearable />
            </el-form-item>
            <p style="color: #666; font-size: 12px; user-select: none">注：总包负责人负责二维码管理及投诉处置，请正确选择！</p>

            <el-form-item v-for="(item, index) in taskForm.subcontractors" :key="index" label="分包单位" prop="subcontractors" label-width="100%">
              <div class="subBox">
                <div class="subList">
                  <el-input style="width: 48%; margin-right: 10px" v-model="item.subcontractorsName" placeholder="请输入分包单位" clearable />
                  <el-input style="width: 48%" v-model="item.subcontractorsPhone" placeholder="负责人手机号" clearable />
                </div>
                <el-button @click="deleteSub(index)" class="delBtn">删除</el-button>
              </div>
            </el-form-item>
            <p style="font-size: 14px; color: dodgerblue; cursor: pointer" @click="addSub">
              <i class="el-icon-plus"></i> 添加分包单位
            </p>
          </div>
        </div>
      </el-form>
      <!-- 操作按钮 -->
      <div class="operate">
        <el-button @click="goBack" v-if="callType == 'info'">返回</el-button>
        <template v-else>
          <el-button @click="goBack">取消</el-button>
          <el-button @click="submitForm" type="primary">保存</el-button>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { getProjectInfoOneById, getComplaintAddOREdit , getComplaintEditOREdit } from '@/api/unpaidWages/monitor'
import { getGeneralContractorList, getGeneralContractorContactList } from '@/api/public'
import { notifySuccess } from '@/utils/modal'
import { codeToText } from 'element-china-area-data'

export default {
  name: 'TaskMonitor',
  data() {
    return {
      count: 0,
      taskView: false,
      showSearch: true,
      loading: false,
      title: '',
      addOrUpdate: false,
      status: [
        {
          value: 0,
          label: '运行',
        },
        {
          value: 1,
          label: '暂停',
        },
      ],
      taskForm: {
        subcontractors: [
          {
            subcontractorsName: '',
            subcontractorsPhone: '',
          },
        ],
        generalContractor: "",
        generalContractorId: "",
        projectAddressStr: '',
        generalContractorContactId: '',
        generalContractorContact: '',
        generalContractorPhone: ''
      },
      openCron: false,
      expression: '',
      // 总包单位列表
      generalContractorOptions: [],
      // 总包负责人列表
      generalContractorContactOptions: [],
      curId: null,
      callType: ''
    }
  },
  computed: {
    rules() {
      const validateGeneralContractor = (rule, value, callback) => {
        if (!this.taskForm.generalContractorContact && !this.taskForm.generalContractorPhone) {
          callback(new Error('总包负责人信息不能为空'))
        } else if (!this.taskForm.generalContractorContact) {
          callback(new Error('总包负责人姓名不能为空'))
        } else if (!this.taskForm.generalContractorPhone) {
          callback(new Error('总包负责人手机号不能为空'))
        } else if (!/^1[3-9]\d{9}$/.test(this.taskForm.generalContractorPhone)) {
          callback(new Error('请输入正确的手机号码'))
        } else {
          callback()
        }
      }

      return {
        projectName: [{ required: true, message: '项目名称不能为空', trigger: 'blur' }],
        approvalNumber: [{ required: true, message: '施工许可/备案号不能为空', trigger: 'blur' }],
        selectedOptions: [{ required: false, message: '项目地址不能为空', trigger: 'blur' }],
        address: [{ required: false, message: '项目详细地址不能为空', trigger: 'blur' }],
        projectBudget: [
          { required: true, message: '项目金额不能为空', trigger: 'blur' },
          { pattern: /^\d+(\.\d+)?$/, message: '请输入数字', trigger: 'blur' },
        ],
        generalContractor: [{ required: true, message: '总包单位不能为空', trigger: 'blur' }],
        generalContractorContact: [
          { validator: validateGeneralContractor, trigger: 'blur' }
        ],
      }
    }
  },
  mounted() {
    this.curId = this.$route.query.id
    this.callType = this.$route.query.type || ''
    
    if (this.curId) {
      this.projectInfoOneById()
    }
    this.generalContractorList()
    console.log(this.$route.query)
  },
  methods: {
    goBack() {
      this.$router.push({ path: `/laborRelations/unpaidWages/monitor/online` })
    },
    handleChange(e) {
      this.taskForm.projectAddressStr = `${codeToText[e[0]]} ${codeToText[e[1]]} ${codeToText[e[2]]}`
    },
    submitForm() {
      this.$refs.taskFormRefs.validate((valid) => {
        if (valid) {
          const params = {
            ...this.taskForm,
          }
          
          // 如果是编辑，需要添加id参数
          if (this.curId) {
            params.id = this.curId
          }

          // 根据是否有curId判断是新增还是编辑
          const apiMethod = this.curId ? getComplaintEditOREdit : getComplaintAddOREdit

          apiMethod(params).then(res => {
            console.log(res.code)
            if (res.code == 200) {
              notifySuccess(res.msg)
              this.goBack()
            }
            this.addOrUpdate = false
          }).catch(err => {
            console.error('提交失败:', err)
          })
        }
      })
    },
    deleteSub(index) {
      console.log(index)
      this.taskForm.subcontractors.splice(index, 1)
    },
    addSub() {
      this.taskForm.subcontractors.push({
        subcontractorsName: '',
        subcontractorsPhone: '',
      })
    },
    projectInfoOneById() {
      getProjectInfoOneById({ id: this.curId }).then((res) => {
        this.taskForm = res.data
        
        // 保存原始的generalContractorContactId，不立即转换类型
        const originalContactId = this.taskForm.generalContractorContactId;
        
        // 根据总包单位ID设置总包单位名称（如果列表已加载）
        if(this.taskForm.generalContractorId) {
          this.$nextTick(() => {
            const contractor = this.generalContractorOptions.find(item => 
              String(item.value) === String(this.taskForm.generalContractorId) || 
              Number(item.value) === Number(this.taskForm.generalContractorId)
            );
            if(contractor) {
              this.taskForm.generalContractor = contractor.label;
            }
          });
          // 获取总包负责人列表，传入原始ID用于后续匹配
          this.generalContractorContactList(this.taskForm.generalContractorId, originalContactId);
        }
        console.log(this.taskForm)
      })
    },
    generalContractorList() {
      getGeneralContractorList({deptTypeList: 6}).then(res => {
        if(res && res.data) {
          console.log(res.data.data,'总包单位列表')
          this.generalContractorOptions = res.data.map(item => {
            return {
              label: item.deptName,
              value: item.id, // 保持原始ID类型
            }
          });
          
          // 如果是编辑模式且已有总包单位ID，设置总包单位名称和ID
          if(this.curId && this.taskForm.generalContractorId) {
            const contractor = this.generalContractorOptions.find(item => {
              // 字符串匹配
              if(String(item.value) === String(this.taskForm.generalContractorId)) return true;
              // 数字匹配
              if(Number(item.value) === Number(this.taskForm.generalContractorId)) return true;
              // 严格相等匹配
              if(item.value === this.taskForm.generalContractorId) return true;
              return false;
            });
            if(contractor) {
              this.$nextTick(() => {
                this.taskForm.generalContractorId = contractor.value; // 使用选项中的原始value
                this.taskForm.generalContractor = contractor.label;
              });
            }
          }
        }
      }).catch(err => {
        console.log(err);
      })
    },
    handleChangeContractor(value) {
      this.generalContractorOptions.forEach((item) => {
        if(item.value === value) {
          this.taskForm.generalContractor = item.label;
        }
      })
      this.taskForm.generalContractorContact = "";
      this.taskForm.generalContractorContactId = "";
      this.taskForm.generalContractorPhone = "";
      this.generalContractorContactList(value);
      console.log("选择了选项", value, this.taskForm.generalContractor);
    },
    // 获取总单位负责人下拉列表
    generalContractorContactList(deptId, originalContactId = null) {
      getGeneralContractorContactList({deptId,type:10}).then(res => {
        console.log(res)
        // 验证数据合法性
        if(res && res.data) {
          // 数据赋值，确保value类型一致（统一使用原始ID类型）
          this.generalContractorContactOptions = res.data.map(item => {
            return {
              label: item.name,
              value: item.id, // 保持原始ID类型
              // 后端字段通常是 phone；这里做个兼容兜底
              phone: item.phone || item.mobile || item.phoneNumber || item.phonenumber || '',
            }
          });
          
          // 如果是编辑模式，根据ID设置总包负责人ID和名称
          if(this.curId) {
            // 使用传入的原始ID或当前表单中的ID
            const contactIdToMatch = originalContactId || this.taskForm.generalContractorContactId;
            
            if(contactIdToMatch) {
              // 尝试多种类型匹配
              const contact = this.generalContractorContactOptions.find(item => {
                // 字符串匹配
                if(String(item.value) === String(contactIdToMatch)) return true;
                // 数字匹配
                if(Number(item.value) === Number(contactIdToMatch)) return true;
                // 严格相等匹配
                if(item.value === contactIdToMatch) return true;
                return false;
              });
              
              if(contact) {
                // 设置ID（使用选项中的原始value，确保类型匹配）
                this.$nextTick(() => {
                  this.taskForm.generalContractorContactId = contact.value;
                  this.taskForm.generalContractorContact = contact.label;
                  // 编辑场景：如果后端未返回手机号，则根据负责人自动补全
                  if (!this.taskForm.generalContractorPhone && contact.phone) {
                    this.taskForm.generalContractorPhone = contact.phone;
                  }
                });
              } else {
                // 如果找不到匹配项，尝试直接使用原始ID（可能是字符串类型）
                this.$nextTick(() => {
                  this.taskForm.generalContractorContactId = contactIdToMatch;
                });
              }
            }
          }
        }
      })
    },
    handleChangeContractorContact(value) {
      this.generalContractorContactOptions.forEach((item) => {
        if(item.value === value) {
          this.taskForm.generalContractorContact = item.label;
          // 选择负责人后，自动带出手机号
          this.taskForm.generalContractorPhone = item.phone || '';
        }
      })
      console.log("选择了选项", value, this.taskForm.generalContractorContact);
    }
  }
}
</script>

<style scoped>
.app-container {
  background: #f7f8f9;
}
.main {
  border: #fff 1px solid;
  border-radius: 10px;
  background: #fff;
  padding: 10px;
}
.main h4 {
  line-height: 30px;
}
.subBox {
  width: 30vw;
  border: #eee 1px solid;
  border-radius: 10px;
  padding: 10px;
}
.formFlxe {
  display: flex;
  justify-content: center;
}
.delBtn {
  margin-top: 20px;
  float: right;
}
.operate {
  display: flex;
  margin-top: 20px;
  justify-content: center;
}

.formLabelRight {
  margin-left: 10vw;
}
</style>
